import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint.tsx';
import { PageIndices } from '../../../common/i-doc/i-doc.registry.ts';
import { LegacyColumn, LegacyListTable, yesNo } from '@components/pm/legacy/LegacyListTable.tsx';
import { LegacyClient, pmLegacyService } from '@services/pm-legacy.service.ts';

const COLUMNS: LegacyColumn<LegacyClient>[] = [
  { label: 'ID', render: (r) => r.id },
  {
    label: 'ПІБ',
    render: (r) => (
      <>
        <Typography variant="body2" fontWeight={500}>{r.fullName || '—'}</Typography>
        {r.isDeleted && <Typography variant="caption" color="error">видалений</Typography>}
      </>
    ),
  },
  { label: 'Організація', render: (r) => (r.orgId ? `${r.orgName ?? '—'} (#${r.orgId})` : null) },
  { label: 'Статус', render: (r) => r.status },
  { label: 'Стать', render: (r) => r.sex },
  { label: 'Логін', render: (r) => r.login },
  { label: 'Телефон', render: (r) => r.phone, nowrap: true },
  { label: 'Рік нар.', render: (r) => r.bornYear },
  { label: 'Створив', render: (r) => (r.createdById ? `${r.createdByName ?? '—'} (#${r.createdById})` : null) },
  { label: 'Сам зареєструвався', render: (r) => yesNo(r.selfRegistered), align: 'center' },
  { label: 'Реєстрація', render: (r) => r.registeredAt, nowrap: true },
  { label: 'Остання подія', render: (r) => r.lastEventAt, nowrap: true },
  { label: 'Остання оплата', render: (r) => (r.lastPaymentAt ? `${r.lastPaymentAt}${r.lastPaymentSum ? ` · ${r.lastPaymentSum}` : ''}` : null), nowrap: true },
];

const PmLegacyClientsPageContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  return (
    <Box data-i-doc={PageIndices.PM_LEGACY_CLIENTS}>
      <PageHint iDoc={PageIndices.PM_LEGACY_CLIENTS} />
      <LegacyListTable
        storageKey="pm-legacy-clients"
        searchLabel="Пошук: ID, ПІБ, логін, телефон"
        columns={COLUMNS}
        fetch={pmLegacyService.getClients}
        withOrgFilter
        initialOrgId={searchParams.get('orgId') ?? ''}
      />
    </Box>
  );
};

export const PmLegacyClientsPage: React.FC = () => (
  <DashboardLayout>
    <PmLegacyClientsPageContent />
  </DashboardLayout>
);
